import { setupEditMode } from './accordion_edit.js';

var SLIDESHOWS_PER_PAGE = 20;
var ownerLogin = window.location.toString().split('/')[3];

var findSelectedTab = function (selected_tab) {
  var temp = selected_tab.siblings('div').filter(function (index) {
    return !$(this).hasClass('hide');
  });
  return temp;
};

var selectFirstSlideshow = function () {
  //Don't wory about the hard coded pptTab. Its just that we need a starting point from where we can iterate.'
  var selectedTab = findSelectedTab($('a.pptTab'));
  var temp = selectedTab
    .children('ul.clearfix')
    .children(':first-child')
    .children('a.j-imageanchor');
  temp.addClass('selected');
  return temp;
};

//Gloabal variable which stores what image is currently selected.
var selectedSlideshow = selectFirstSlideshow();

var constructSlideshowLi = function (ss_type, element, slideshow) {
  var clone = element.prev().clone();
  clone.attr('id', ss_type + '_' + slideshow.id);
  var anchorEle = clone.find('a');
  anchorEle.attr('title', slideshow.title);
  anchorEle.attr('data-hits', slideshow.hits_count);
  anchorEle.attr('href', slideshow.url);
  var imageEle = clone.find('img');
  imageEle.attr('alt', slideshow.title);
  imageEle.attr('src', slideshow.thumbnail_image);
  imageEle.attr('data-secret-url', slideshow.secret_url);
  return clone;
};

var insertSlideshows = function (element, ss_type, slideshows) {
  $.each(slideshows, function (index, slideshow) {
    var slideshowEle = constructSlideshowLi(ss_type, element, slideshow);
    element.before(slideshowEle);
  });
};

function globalVariables() {
  const globals = document.querySelector('[data-globals]');
  let variables = {};
  if (globals && globals.dataset) {
    variables = JSON.parse(globals.dataset.globals || '{}');
  }

  return variables;
}

var loadDefaultSs = function (data, selected_tab) {
  const globals = globalVariables();

  var firstChild = selected_tab
    .next()
    .children()
    .children()
    .children('a.j-imageanchor');
  if (firstChild.length > 0) {
    var secretKey = firstChild.children().children('img').data('secret-url');
    var link = firstChild.attr('href');
    var title = firstChild.attr('title') || firstChild.attr('original-title');
    var newEmbedLink =
      '/slideshow/embed_code/key/' +
      secretKey +
      '?hostedIn=' +
      globals.hosted_in +
      '&referer=' +
      globals.referer;
    var iframe = selected_tab
      .parents('div#main_div')
      .children('div.pptOnDisplay')
      .children('iframe');
    var oldEmbedLink = selected_tab
      .parents('div#main_div')
      .children('div.pptOnDisplay')
      .children('iframe')
      .attr('src');
    if (oldEmbedLink != newEmbedLink) {
      var metaData = iframe.next().children(':first-child');
      var metaDataHits = metaData.next();
      var hits = firstChild.attr('data-hits');
      iframe.attr('src', newEmbedLink);
      metaData.attr('href', link);
      metaData.attr('title', title);
      metaData.text(title);
      metaDataHits.text(hits + ' views');
    }
  }
};

var showHideDiv = function (selected_tab) {
  var divToHide = findSelectedTab(selected_tab);
  var divToShow = selected_tab.next();
  if (divToHide[0] == divToShow[0]) {
    return;
  }

  var callback = function () {
    divToHide.addClass('hide');
    divToShow.removeClass('hide');
  };

  divToHide.slideUp('slow');
  divToShow.slideDown('slow', callback);
  $('.moreRelated').jScrollPane();
};

$('#j-iframe-copier').click(function (e) {
  e.preventDefault();
  const contents = document.getElementById(e.target.dataset.clipboardTarget)
    .value;
  navigator.clipboard.writeText(contents).then(function () {
    $('#j-iframe-msg').css('display', 'block');
  });
});

var showEmbed = function () {
  $('.embed-overlay-container').toggle();
  $('#j-iframe-msg').css('display', 'none');
};

window.show_embed = showEmbed;

$('.j-upload_cta').click(function (e) {
  top.set_window_location('/upload');
});

//TODO: Dry this function
var registerListeners = function (config) {
  const globals = globalVariables();
  //capture the click on the thumbnails
  $('ul.j-more-related').on('click', '.j-imageanchor', function (e) {
    _gaq.push(['_trackEvent', 'slideshelf', 'thumbnail_clicked']);
    e.preventDefault();
    var selectedPpt = $(this);
    var iframe = selectedPpt
      .parents('div#main_div')
      .children('div.pptOnDisplay')
      .children('iframe');
    var link = selectedPpt.attr('href');
    var title =
      selectedPpt.attr('title') || selectedPpt.attr('original-title');
    var newEmbedLink =
      '/slideshow/embed_code/key/' +
      selectedPpt.children().children('img').data('secret-url') +
      '?hostedIn=' +
      globals.hosted_in +
      '&referer=' +
      globals.referer;
    var oldEmbedLink = selectedPpt
      .parents('div#main_div')
      .children('div.pptOnDisplay')
      .children('iframe')
      .attr('src');
    // if the link is the same, no need to load the iframe again.
    if (oldEmbedLink != newEmbedLink) {
      //Don't parse DOM until and unless required
      var metaData = iframe.next().children(':first-child');
      var metaDataHits = metaData.next();
      var hits = selectedPpt.attr('data-hits');
      iframe.attr('src', newEmbedLink);
      metaData.attr('href', link);
      metaData.attr('title', title);
      metaData.text(title);
      selectedSlideshow.removeClass('selected');
      selectedPpt.addClass('selected');
      selectedSlideshow = selectedPpt;
      metaDataHits.text(hits + ' views');
    }
  });

  $.each(
    {
      '.j-pptTab': 'pptList',
      '.j-docTab': 'docList',
      '.j-infogrTab': 'infogrList',
    },
    function (key, value) {
      $(key).bind('click', function (e) {
        e.preventDefault();
        var selectedTab = $(this);
        showHideDiv(selectedTab);
        loadDefaultSs(value, selectedTab);
      });
    }
  );

  //load more slideshows via ajax

  $.each(['presentations', 'documents', 'infographics'], function (
    index,
    ss_type
  ) {
    $('#show_more_' + ss_type).click(function (e) {
      return (function (e) {
        $(e.target).next().show();
        $(e.target).hide();
        $.ajax({
          url:
            '/' +
            encodeURIComponent(ownerLogin) +
            '/slideshelf/load_more_slideshows',
          data: {
            slideshow_type: ss_type,
            offset: config[`${ss_type}_offset`],
          },
          success: function (response) {
            if (response['has_more_' + ss_type]) {
              $(e.target).show();
            }
            $(e.target).next().hide();
            insertSlideshows($(e.target).parent(), ss_type, response[ss_type]);
            // Reloading jScrollpane plugin
            $('.moreRelated').jScrollPane();
            config[`${ss_type}_offset`] += response[ss_type].length;
          },
          dataType: 'json',
          async: true,
        });
      })(e);
    });
  });

  //Tipsy tooltips
  // Disabled as 'live' is gone
  // $('.j-tooltip').tipsy({ gravity: 'n',live: true });
};

var editSlideshelf = function () {
  var width = $(window).width();
  var height = $(window).height();
  var iframeLargeWidth = 760;
  var iframeLargeHeight = 570;
  var iframeSmallWidth = 490;
  var iframeSmallHeight = 470;
  var widthTopbar = 0;
  // When embeded in small size
  if (width === iframeSmallWidth && height === iframeSmallHeight) {
    widthTopbar = 480 - 11;
    //hide the side bar
    $('div.related-tab').hide();
    //udpate the embed button topnav
    $('.topbar').css('width', widthTopbar);
    //update the embed window
    $('.embed-overlay-container').css('width', widthTopbar - 30);
    $('.embed-overlay-container').css('height', 349);
  }
  // when embeded in large size
  else if (width === iframeLargeWidth && height === iframeLargeHeight) {
    var widthPptOnDisplay = 595;
    var widthMorerelated = 154;
    widthTopbar = widthPptOnDisplay + widthMorerelated - 10;
    // set the height in which the slideshow is loaded.
    $('iframe.ssIframeLoader').css('width', widthPptOnDisplay);
    $('.pptOnDisplay').css('width', widthPptOnDisplay);
    $('iframe.ssIframeLoader').css('height', 497);

    //set the height of the embed bar and embed overlay
    $('.topbar').css('width', widthTopbar);
    $('.embed-overlay-container').css('width', widthTopbar - 30);
    $('.embed-overlay-container').css('height', 457);

    //set the realted tab settings
    $('.moreRelated').css('width', widthMorerelated);
    $('.moreRelated').css('height', 425);
    $('.related-tab').css('height', 495);
    $('.related-tab').css('width', widthMorerelated);
    $('.jspContainer').css('width', 154);
    $('.jspContainer').css('height', 425);

    //scale the images inside the related
    $('.jspPane li a').css('width', 120);
    $('.jspPane li a').css('height', 92);
    $('.jspPane li a span').css('width', 120);
    $('.jspPane li a span').css('height', 92);
    $('.jspPane li a span img').css('min-height', 92);
    $('.jspPane li a span img').css('width', 120);

    // Re-initializing jscrollPane plugin to rescale jspContainer according to resized thumbs for large embed
    $('.moreRelated').jScrollPane();
  }
};

// This is called on save from the parent window
window.get_params = function () {
  var list = '',
    sorting_order = $('#sorting_order').val(),
    tab_displayed = [],
    tabs_hidden = [];
  if (sorting_order === '3') {
    $('.sortable').each(function (index, element) {
      if ($(element).parents('.j-accordionList').hasClass('hide')) {
        list += $(element).sortable('serialize');
      } else {
        list = $(element).sortable('serialize') + list;
      }
    });
    list = list.match(/[0-9]+/g);
  }
  return { sorting_order: sorting_order, slideshows: list };
};

var getUrlVars = function (url) {
  url = url ? url : window.location.href;
  var vars = [],
    hash;
  var hashes = url.slice(url.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
};

var embedSizeSelectedToggle = function (object) {
  $('.embed-size-selected').removeClass('embed-size-selected');
  $(object).addClass('embed-size-selected');
};
$('.j-embed-cancel').click(function () {
  $('.embed-overlay-container').toggle();
  $('#j-iframe-msg').css('display', 'none');
});

let embedLinks = null;
function getEmbedLinks() {
  if (!embedLinks) {
    const json = $('.h-embed-code').data('embed-links');
    if (json) {
      embedLinks = json;
    } else {
      embedLinks = {
        small: $('.h-embed-code').attr('embed_link_small'),
        medium: $('.h-embed-code').attr('embed_link_medium'),
        large: $('.h-embed-code').attr('embed_link_large'),
      };
    }
  }

  return embedLinks;
}

$('.j-embed-small').click(function (e) {
  embedSizeSelectedToggle(this);
  $('.h-embed-code').val(getEmbedLinks().small);
  $('#j-iframe-msg').css('display', 'none');
});

$('.j-embed-medium').click(function (e) {
  embedSizeSelectedToggle(this);
  $('.h-embed-code').val(getEmbedLinks().medium);
  $('#j-iframe-msg').css('display', 'none');
});

$('.j-embed-large').click(function (e) {
  embedSizeSelectedToggle(this);
  $('.h-embed-code').val(getEmbedLinks().large);
  $('#j-iframe-msg').css('display', 'none');
});

$(document).ready(function () {
  const globals = globalVariables();
  // Call for jscrollPane plugin used for customizing the scroll bar
  $('.moreRelated').jScrollPane();
  // Don't mess up if you are hosted within slidehsare
  if (globals.hostedIn !== 'slideshare') {
    editSlideshelf();
  }
  var config = {
    presentations_offset: SLIDESHOWS_PER_PAGE,
    documents_offset: SLIDESHOWS_PER_PAGE,
    infographics_offset: SLIDESHOWS_PER_PAGE,
  };
  registerListeners(config);
  if (getUrlVars(window.location.toString()).mode === 'edit') {
    setupEditMode();
  }
  window._gaq = _gaq || [];
  _gaq.push(['_trackPageview']);
  _gaq.push(['_trackEvent', 'slideshelf', 'load', undefined, undefined, true]);

  $('.slideshelf-author').bind('click', function () {
    if (globals.hostedIn !== 'slideshare') {
      window.open('https://' + window.location.host + '/' + ownerLogin);
    }
  });
});
